import { render, staticRenderFns } from "./JointScreenCenter.vue?vue&type=template&id=4304f627&scoped=true&"
import script from "./JointScreenCenter.vue?vue&type=script&lang=js&"
export * from "./JointScreenCenter.vue?vue&type=script&lang=js&"
import style0 from "./JointScreenCenter.vue?vue&type=style&index=0&id=4304f627&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4304f627",
  null
  
)

export default component.exports